import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AJSGiftCardsCommonsSessionStorageService, GiftCardsCommonsSessionStorageServiceType } from '@shared/services/upgrades/ib-gift-cards-commons-session-storage-bridge.service';
import { lastValueFrom } from 'rxjs';
import { GiftCardThemeItem } from '@src/app/core/models/campaigns.model';


@Component({
    selector: 'ib-gift-cards-theme-item-component',
    standalone: true,
    imports: [TranslateModule, FormsModule, CommonModule],
    templateUrl: './ib-gift-cards-theme-item.component.html',
    styleUrls: ['./ib-gift-cards-theme-item.component.scss']
})

export class IbGiftCardsThemeItemComponent implements OnInit {

    @Input() model: GiftCardThemeItem;
    @Input() show;
    @Output() themeChange = new EventEmitter();
    cardText: string;

    constructor (
        private translateService: TranslateService,
        @Inject(AJSGiftCardsCommonsSessionStorageService) private CommonsSessionStorageService: GiftCardsCommonsSessionStorageServiceType
    ) {}
    ngOnInit (): void {
        this.initializeTranslates();
    }

    initializeTranslates = async ():Promise<void> => {
        this.cardText = await lastValueFrom(this.translateService.get(this.model.text));
    };

    updateQuadrigam = () => {
        this.CommonsSessionStorageService.set('theme', this.model.theme);
        this.themeChange.emit(this.model.theme);
    };

    
}
